var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Information")]),_vm._v(" Der Adminbereich ist bis jetzt nur Firmenkunden vorbehalten. ")])}]

export { render, staticRenderFns }